import { t } from 'i18next';

import EmailDocumentsDialog from '~components/EmailDocumentsDialog/EmailDocumentsDialog';
import { OutboundEmailEntry } from '~hooks/useOutboundEmails/sendOutboundEmails';
import useProjectEmailDraftsQuery from '~queries/useProjectEmailDraftsQuery';

interface EmailQuoteDialogProps {
  companyId: string;
  isOpen: boolean;
  onClose: () => void;
  onSend: (emails: OutboundEmailEntry[]) => Promise<void>;
  projectIds: string[];
}

function EmailQuoteContent({
  companyId,
  onClose,
  onSend,
  projectIds,
}: Omit<EmailQuoteDialogProps, 'isOpen'>) {
  const { drafts, isError, isLoading, refetch } = useProjectEmailDraftsQuery(
    companyId,
    projectIds,
  );

  return (
    <EmailDocumentsDialog
      drafts={drafts}
      isError={isError}
      isLoading={isLoading}
      labels={{
        description: t('project.email_quote.description'),
        noEmails: t('project.email_quote.no_emails'),
        send: t('actions.send'),
        title: t('project.email_quote.title'),
      }}
      onClose={onClose}
      onRetry={refetch}
      onSend={onSend}
    />
  );
}

export default function EmailQuoteDialog({
  isOpen,
  ...contentProps
}: EmailQuoteDialogProps) {
  return isOpen ? <EmailQuoteContent {...contentProps} /> : null;
}
